<template>
    <div class="test__wrapper" v-if="url">
        Для прохождения теста перейдите по
        <a :href="url" target="__blank">cсылке</a>
    </div>
    <div class="test__wrapper" v-else-if="url === false">
        Тест не найден
    </div>
</template>

<script>
export default {
    name: 'TestingStart',
    data:() => ({
        url: null,
    }),
    async mounted() {
        this.url = await this.$store.dispatch(
            'startTest',
            {
                testId: this.$route.params.id,
            },
        ) || false;
        if (this.url) {
            window.location = this.url;
        }
    },
};
</script>

<style lang="scss" scoped>
    @import '../styles/rem';

    .test__wrapper {
        margin-top: rem(40);
        text-align: center;

        &, & > * {
            font-family: "Montserrat";
            font-style: normal;
            font-weight: bold;
            font-size: rem(32);
            line-height: rem(39);
            color: #2A2626;
        }

        a {
            color: #4663AB;
        }
    }

</style>
